import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { TruckSize } from '../../../../../../common/constants';

export function truckSealDataValidator(formGroup: FormGroup): void {
  const truckSealNumber = formGroup.get('truckSeal').get('sealNumber');
  const truckSealPhoto = formGroup.get('truckSeal').get('data');
  const trailerSealNumber = formGroup.get('trailerSeal').get('sealNumber');
  const trailerSealPhoto = formGroup.get('trailerSeal').get('data');
  const sealed = formGroup.get('sealed');

  if (sealed.value) {
    const truckSize = formGroup.get('truckSize').value;
    if (truckSize === TruckSize.XL) {
      setRequiredToControl(truckSealNumber);
      setRequiredToControl(truckSealPhoto);
      setRequiredToControl(trailerSealNumber);
      setRequiredToControl(trailerSealPhoto);
    } else if (truckSize === TruckSize.XXL) {
      removeValidatorsFromControl(truckSealNumber);
      removeValidatorsFromControl(truckSealPhoto);
      setRequiredToControl(trailerSealNumber);
      setRequiredToControl(trailerSealPhoto);
    } else {
      setRequiredToControl(truckSealNumber);
      setRequiredToControl(truckSealPhoto);
    }

    if (formGroup.dirty) {
      validateIdAndPhoto(truckSealNumber, truckSealPhoto);
      validateIdAndPhoto(trailerSealNumber, trailerSealPhoto);
      validateTruckOrTrailerValue(truckSealNumber, trailerSealNumber, sealed);
    }
  } else {
    removeValidatorsFromControl(truckSealNumber);
    removeValidatorsFromControl(truckSealPhoto);
    removeValidatorsFromControl(trailerSealNumber);
    removeValidatorsFromControl(trailerSealPhoto);
    formGroup.get('sealed').markAsDirty();
  }

  formGroup.get('truckSeal').updateValueAndValidity({ onlySelf: true });
  formGroup.get('trailerSeal').updateValueAndValidity({ onlySelf: true });
}

function validateIdAndPhoto(id: AbstractControl, photo: AbstractControl): void {
  if (id.value || photo.value) {
    setRequiredToControl(id);
    setRequiredToControl(photo);
  } else {
    removeValidatorsFromControl(id);
    removeValidatorsFromControl(photo);
  }
}

function validateTruckOrTrailerValue(
  truckSealNumber: AbstractControl,
  trailerSealNumber: AbstractControl,
  sealCheck: AbstractControl,
): void {
  if (!truckSealNumber.value && !trailerSealNumber.value) {
    sealCheck.markAsPristine();

    setRequiredToControl(truckSealNumber);
    setRequiredToControl(trailerSealNumber);
  }

  if (truckSealNumber.dirty && !trailerSealNumber.value) {
    setRequiredToControl(truckSealNumber);
    trailerSealNumber.markAsPristine();
  }

  if (trailerSealNumber.dirty && !truckSealNumber.value) {
    setRequiredToControl(trailerSealNumber);
    truckSealNumber.markAsPristine();
  }
}

function setRequiredToControl(control: AbstractControl): void {
  control.setValidators(Validators.required);
  control.updateValueAndValidity({
    onlySelf: true,
  });
}

function removeValidatorsFromControl(control: AbstractControl): void {
  control.clearValidators();
  control.updateValueAndValidity({
    onlySelf: true,
  });
}
